import { Outlet } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { useLocation } from "react-router-dom";

export default function Layout() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1 pt-16">
        {!isHome && <Breadcrumb />}
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}